<ng-container *ngIf="bookingStore.loaded$ | async; else loader">
  <div class="checkout-wrapper" *ngIf="selectedPlan === BookingPlans.Pro; else trial">
    <div class="checkout-list-header">
      {{ '+BOOKING.VOUCHER.ACTIVATE.TITLE' | translate }}
    </div>

    <div class="checkout-content">
      <div
        class="checkout-list-wrapper"
        *ngIf="bookingStore.getVoucherValidationState$ | async as state"
      >
        <div class="checkout-list">
          <p class="activate-info activate-info-{{ state }}">
            {{ '+BOOKING.VOUCHER.ACTIVATE.INFO' | translate }}
          </p>
          <div class="activate-code">
            <div
              class="activate-code-wrapper flex flex-row gap-[16px] flex-1 w-full min-w-full h-full min-h-full"
            >
              <div class="input-wrapper">
                <vi-input
                  class="input-{{ state }}"
                  [showError]="true"
                  (valueChange)="onInputValueChange($event)"
                  [value]="voucherInputValue"
                >
                </vi-input>
                <mat-error
                  *ngIf="state === VoucherValidationResponse.Invalid && validationTriggered"
                  class="activate-error"
                >
                  <mat-icon class="error-icon"> warning </mat-icon>
                  {{ '+BOOKING.VOUCHER.ACTIVATE.INVALID' | translate }}
                </mat-error>
                <mat-error
                  *ngIf="state === VoucherValidationResponse.AlreadyUsed && validationTriggered"
                  class="activate-error"
                >
                  <mat-icon class="error-icon"> warning </mat-icon>
                  {{ '+BOOKING.VOUCHER.ACTIVATE.USED' | translate }}
                </mat-error>
              </div>
              <button
                class="activate-button"
                mat-stroked-button
                gtm="onSelect"
                gtmAction="Booking Stepper"
                gtmCategory="booking"
                color="primary"
                (click)="onActivateCode()"
                [disabled]="!voucherInputValue"
                data-at-back-button
              >
                {{ '+BOOKING.VOUCHER.ACTIVATE.ACTIVATE_CODE' | translate }}
              </button>
            </div>
            <div
              *ngIf="state === VoucherValidationResponse.Valid && validationTriggered"
              class="activate-success"
            >
              <mat-icon class="success-icon"> check_circle </mat-icon>
              {{ '+BOOKING.VOUCHER.ACTIVATE.SUCCESS' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="checkout-summary-wrapper">
        <div class="checkout-summary__cell">
          <div class="flex flex-row justify-between items-stretch">
            <p class="checkout-summary__title">
              {{ '+BOOKING.VOUCHER.DEVICES.CHOSEN_PACKAGE' | translate }}
            </p>
            <button
              class="back-button"
              gtm="onGoToPage"
              gtmAction="Home Page"
              gtmCategory="booking"
              mat-stroked-button
              (click)="onBack()"
            >
              {{ 'GENERAL.BUTTON.BACK' | translate }}
            </button>
          </div>
          <p class="checkout-summary__package">
            {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
          </p>
        </div>

        <div class="checkout-summary__cell">
          <div class="flex flex-row justify-between items-stretch">
            <p class="checkout-summary__title">
              {{ '+BOOKING.VOUCHER.ACTIVATE.SELECTED_DEVICE' | translate }}
            </p>
          </div>

          <ng-container *ngIf="bookingStore.selectedDevices$ | async as selectedDevices">
            <div
              class="checkout-summary__entry flex flex-col"
              installation-item
              data-at-installation
              *ngFor="let device of selectedDevices"
            >
              <span class="entry-name">{{ bookingService.getDeviceTitle(device) }}</span>
              <span class="entry-address">{{ device.location }}</span>
            </div>
          </ng-container>
        </div>

        <div *ngIf="document" class="checkout-summary__cell">
          <div class="checkout-summary__checkbox-tos flex flex-row justify-start items-center">
            <mat-checkbox
              gtm="onToggle"
              gtmAction="Booking Checkout"
              gtmCategory="booking"
              [(ngModel)]="tosAccepted"
              (ngModelChange)="onTosCheckboxChange($event)"
            >
            </mat-checkbox>
            <span
              [innerHTML]="
                '+BOOKING.SUMMARY_USER_AGGREEMENT.TEXT'
                  | translate
                  | link: '{key}':'+BOOKING.SUMMARY_USER_AGGREEMENT.KEY_TRANSLATION':document.link
              "
            ></span>
          </div>
          <button
            class="subscribe-now-button"
            mat-raised-button
            color="primary"
            (click)="onSubscribeNow()"
            gtm="onSelect"
            gtmAction="Pro package"
            gtmCategory="booking"
            [disabled]="onDisabled()"
          >
            {{ '+BOOKING.VOUCHER.ACTIVATE.SUBSCRIBE' | translate }}
          </button>
        </div>
      </div>
    </div>
    <app-voucher-subscription-summary
      class="!hidden"
      (continue)="onSubscribeNow()"
      data-at-checkout-section
    >
    </app-voucher-subscription-summary>
  </div>

  <ng-template #trial>
    <div class="checkout-list-header">
      {{ '+BOOKING.VOUCHER.TRIAL.TITLE' | translate }}
    </div>

    <div class="checkout-content">
      <div class="checkout-list-wrapper">
        <div class="checkout-list">
          <div class="checkout-summary__info">
            {{ '+BOOKING.VOUCHER.TRIAL.INFO' | translate }}
          </div>
          <ng-container *ngIf="bookingStore.selectedDevices$ | async as selectedDevices">
            <div
              class="checkout-summary__device"
              installation-item
              data-at-installation
              *ngFor="let device of selectedDevices"
            >
              <span>{{ bookingService.getDeviceTitle(device) }}</span>
              <span>{{ device.location }}</span>
              <span> {{ device.vin }} </span>
            </div>
          </ng-container>
        </div>
      </div>

      <div
        class="checkout-summary-wrapper"
        *ngIf="bookingStore.selectedDevices$ | async as selectedDevices"
      >
        <div class="checkout-summary__cell">
          <p class="checkout-summary__cart">
            {{ '+BOOKING.VOUCHER.TRIAL.SHOPPING_CART' | translate }}
          </p>
          <div class="checkout-summary__table">
            <p>{{ '+BOOKING.VOUCHER.TRIAL.PACKAGE_INFO' | translate }}</p>
            <p>x{{ selectedDevices.length }}</p>
          </div>

          <div class="checkout-summary__price">
            {{ '+BOOKING.VOUCHER.TRIAL.PRICE' | translate }}
          </div>

          <div
            *ngIf="document"
            class="checkout-summary__checkbox-tos flex flex-row justify-start items-center"
          >
            <mat-checkbox
              gtm="onToggle"
              gtmAction="Booking Checkout"
              gtmCategory="booking"
              [(ngModel)]="tosAccepted"
              (ngModelChange)="onTosCheckboxChange($event)"
            >
            </mat-checkbox>
            <span
              [innerHTML]="
                '+BOOKING.SUMMARY_USER_AGGREEMENT.TEXT'
                  | translate
                  | link: '{key}':'+BOOKING.SUMMARY_USER_AGGREEMENT.KEY_TRANSLATION':document.link
              "
            ></span>
          </div>
          <button
            class="subscribe-now-button"
            mat-raised-button
            color="primary"
            (click)="onSubscribeToTrial()"
            gtm="onSelect"
            gtmAction="Pro package"
            gtmCategory="booking"
            [disabled]="!this.tosAccepted"
          >
            {{ '+BOOKING.VOUCHER.ACTIVATE.SUBSCRIBE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #loader>
  <vi-loader data-at-loader-booking [isLoading]="true"></vi-loader>
</ng-template>
